var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('users-table'),_c('fav-users-table'),_c('api-fav-users-table')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }